import React from 'react';
import headerlogo from '../../icons/logo.svg';
import styles from './LogoArea.module.scss';

export const LogoArea: React.FC = () => {
  return (
    <div className={styles.header_logo_area}>
      <img src={headerlogo} />
    </div>
  );
};
